'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("TableHead", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: table-header-group;
  `
});
const TableHead = (props) => {
  return react.jsx("thead", { css: Styles.root, "data-zds": true }, props.children);
};

exports.TableHead = TableHead;
//# sourceMappingURL=TableHead.cjs.js.map
